var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
var _currentWindow, _targetWindow, _listeners, _msgIdGenerator, _appliedEventListeners, _isTerminated, _waitForResponse, waitForResponse_fn, _onMessage, onMessage_fn, _setupSocket, setupSocket_fn, _tryParse, tryParse_fn, _getNextMsgId, getNextMsgId_fn;
class PostMessageSocket {
  constructor(currentWindow, targetWindow) {
    __privateAdd(this, _waitForResponse);
    __privateAdd(this, _onMessage);
    __privateAdd(this, _setupSocket);
    __privateAdd(this, _tryParse);
    __privateAdd(this, _getNextMsgId);
    __privateAdd(this, _currentWindow, void 0);
    __privateAdd(this, _targetWindow, void 0);
    __privateAdd(this, _listeners, {});
    __privateAdd(this, _msgIdGenerator, void 0);
    __privateAdd(this, _appliedEventListeners, []);
    __privateAdd(this, _isTerminated, false);
    __privateSet(this, _currentWindow, currentWindow);
    __privateSet(this, _targetWindow, targetWindow);
    __privateMethod(this, _setupSocket, setupSocket_fn).call(this);
  }
  getDocument() {
    if (__privateGet(this, _isTerminated))
      return;
    return __privateGet(this, _currentWindow).document;
  }
  addListener(type, callback, { once = false } = {}) {
    if (__privateGet(this, _isTerminated))
      return;
    if (!__privateGet(this, _currentWindow))
      return;
    __privateGet(this, _listeners)[type] = { callback, once };
  }
  removeListener(type) {
    __privateGet(this, _listeners)[type] = null;
    delete __privateGet(this, _listeners)[type];
  }
  sendMessage(type, payload) {
    if (__privateGet(this, _isTerminated))
      return;
    if (!__privateGet(this, _targetWindow) && __privateGet(this, _isTerminated))
      return;
    const msgId = __privateMethod(this, _getNextMsgId, getNextMsgId_fn).call(this);
    __privateGet(this, _targetWindow).postMessage(JSON.stringify({ type, payload, msgId, waitForResponse: false }), "*");
    return __privateMethod(this, _waitForResponse, waitForResponse_fn).call(this, msgId);
  }
  sendRequest(type, payload) {
    if (__privateGet(this, _isTerminated))
      return;
    if (!__privateGet(this, _targetWindow) && __privateGet(this, _isTerminated))
      return;
    const msgId = __privateMethod(this, _getNextMsgId, getNextMsgId_fn).call(this);
    __privateGet(this, _targetWindow).postMessage(JSON.stringify({ type, payload, msgId, waitForResponse: true }), "*");
    return __privateMethod(this, _waitForResponse, waitForResponse_fn).call(this, msgId);
  }
  terminate() {
    if (!__privateGet(this, _currentWindow))
      return;
    while (__privateGet(this, _appliedEventListeners).length) {
      const listener = __privateGet(this, _appliedEventListeners).pop();
      __privateGet(this, _currentWindow).removeEventListener("message", listener.handler, listener.useCapture);
    }
    __privateSet(this, _isTerminated, true);
  }
}
_currentWindow = new WeakMap();
_targetWindow = new WeakMap();
_listeners = new WeakMap();
_msgIdGenerator = new WeakMap();
_appliedEventListeners = new WeakMap();
_isTerminated = new WeakMap();
_waitForResponse = new WeakSet();
waitForResponse_fn = function(msgId) {
  if (__privateGet(this, _isTerminated))
    return;
  return new Promise((resolveWaitForResponse, rejectWaitForResponse) => {
    const waitForResponse = (event) => {
      if (event.source !== __privateGet(this, _targetWindow))
        return;
      const index = __privateGet(this, _appliedEventListeners).findIndex((handler2) => handler2._id === msgId);
      if (index === -1)
        return;
      const listener = __privateGet(this, _appliedEventListeners)[index];
      try {
        const response = __privateMethod(this, _tryParse, tryParse_fn).call(this, event);
        if (response.msgId !== msgId)
          return;
        event.stopPropagation();
        __privateGet(this, _currentWindow).removeEventListener("message", listener.handler, listener.useCapture);
        __privateGet(this, _appliedEventListeners).splice(index, 1);
        if (response.error) {
          rejectWaitForResponse(new Error(response.error));
        } else {
          resolveWaitForResponse(response.payload);
        }
      } catch (error) {
        return;
      }
    };
    const handler = waitForResponse.bind(this);
    __privateGet(this, _currentWindow).addEventListener("message", handler, true);
    __privateGet(this, _appliedEventListeners).push({ _id: msgId, handler, useCapture: true });
  });
};
_onMessage = new WeakSet();
onMessage_fn = function(event) {
  return __async(this, null, function* () {
    if (__privateGet(this, _isTerminated))
      return;
    if (!!event.source && event.source !== __privateGet(this, _targetWindow))
      return;
    let message;
    try {
      message = __privateMethod(this, _tryParse, tryParse_fn).call(this, event);
    } catch (error) {
      return;
    }
    if (!message)
      return;
    const listener = __privateGet(this, _listeners)[message.type];
    if (!listener)
      return;
    const respond = ({ error, payload }) => {
      const response = { msgId: message.msgId };
      if (error) {
        response.error = typeof error === "string" ? error : (error == null ? void 0 : error.message) || "Unexpected error";
      } else {
        response.payload = payload;
      }
      __privateGet(this, _targetWindow).postMessage(JSON.stringify(response), "*");
    };
    try {
      if (message.waitForResponse) {
        respond({ payload: yield listener.callback(message.payload) });
      } else {
        yield listener.callback(message.payload);
        respond({ payload: "success" });
      }
    } catch (error) {
      respond({ error });
    }
    if (listener.once) {
      this.removeListener(message.type);
    }
  });
};
_setupSocket = new WeakSet();
setupSocket_fn = function() {
  function* msgIdGenerator() {
    let msgId = 0;
    while (__privateGet(this, _currentWindow) && !__privateGet(this, _isTerminated)) {
      yield `${msgId++}-${new Date().getTime()}`;
    }
  }
  __privateSet(this, _msgIdGenerator, msgIdGenerator.call(this));
  const messageHandler = __privateMethod(this, _onMessage, onMessage_fn).bind(this);
  __privateGet(this, _currentWindow).addEventListener("message", messageHandler, false);
  __privateGet(this, _appliedEventListeners).push({ _id: `START-${new Date().getTime()}`, handler: messageHandler, useCapture: false });
};
_tryParse = new WeakSet();
tryParse_fn = function(event) {
  try {
    return JSON.parse(event.data);
  } catch (err) {
    throw new Error(err);
  }
};
_getNextMsgId = new WeakSet();
getNextMsgId_fn = function() {
  return __privateGet(this, _msgIdGenerator).next().value;
};
function initUpdateHookList(hooks, messageSocket, validator) {
  const pluginHookList = hooks;
  const currentValidator = validator;
  const currentMessageSocket = messageSocket;
  if (!pluginHookList.includes("error")) {
    pluginHookList.push("error");
  }
  return function(currentHooks) {
    return __async(this, null, function* () {
      if (!currentHooks.includes("error")) {
        currentHooks.push("error");
      }
      if (typeof currentValidator === "function") {
        yield currentValidator({ hooks: currentHooks });
      }
      const hookFunctions = {};
      currentHooks.forEach((hook) => {
        if (!pluginHookList.includes(hook)) {
          return currentMessageSocket.sendMessage("error", `The following hook is not valid: ${hook}`);
        }
        hookFunctions[hook] = (payload) => __async(this, null, function* () {
          return yield currentMessageSocket.sendRequest(hook, payload);
        });
      });
      return hookFunctions;
    });
  };
}
function initUpdateHooks(messageSocket) {
  const currentMessageSocket = messageSocket;
  let hooksFromParent = {};
  currentMessageSocket.addListener("error", (payload) => console.warn(payload));
  return function({ hooks, resetHooks }) {
    if (resetHooks) {
      Object.keys(hooksFromParent).forEach((hook) => {
        currentMessageSocket.removeListener(hook);
      });
      hooksFromParent = hooks;
    } else {
      hooksFromParent = __spreadValues(__spreadValues({}, hooksFromParent), hooks);
    }
    Object.keys(hooksFromParent).forEach((hook) => {
      if (typeof hooksFromParent[hook] !== "function" && hooksFromParent[hook] === null) {
        currentMessageSocket.removeListener(hook);
        return;
      }
      currentMessageSocket.addListener(hook, (payload) => hooksFromParent[hook](payload));
    });
    return Object.keys(hooksFromParent).filter((hook) => typeof hooksFromParent[hook] === "function" && hooksFromParent[hook] !== null);
  };
}
function createInitPlugin({ data, settings, hooks }, { container, src, beforeInit, timeout }) {
  const pluginIframe = document.createElement("iframe");
  pluginIframe.src = src;
  pluginIframe.allowFullscreen = "allowfullscreen";
  pluginIframe.style.width = "100%";
  pluginIframe.style.height = "100%";
  pluginIframe.style.border = "0";
  pluginIframe.style.margin = "0";
  pluginIframe.style.padding = "0";
  if (typeof beforeInit === "function") {
    beforeInit({ container, iframe: pluginIframe });
  }
  container.appendChild(pluginIframe);
  return initPlugin({ data, settings, hooks }, { currentWindow: window, targetWindow: pluginIframe.contentWindow, timeout, container });
}
function initPlugin({ data, settings, hooks }, { currentWindow, targetWindow, timeout = null, container }) {
  const messageSocket = new PostMessageSocket(currentWindow, targetWindow);
  const updateHooks = initUpdateHooks(messageSocket);
  updateHooks({ hooks });
  return new Promise((resolve, reject) => {
    messageSocket.addListener("domReady", onDomReady, { once: true });
    let timeoutId = null;
    if (timeout) {
      timeoutId = setTimeout(() => {
        messageSocket.terminate();
        if ((container == null ? void 0 : container.remove) && typeof container.remove === "function") {
          container.remove();
        }
        reject(new Error(`Plugin initialization failed with timeout! You can try to increase the timeout value in the plugin settings. Current value is ${timeout}ms.`));
      }, timeout);
    }
    function onDomReady() {
      return __async(this, null, function* () {
        messageSocket.sendMessage("ackDomReady", {});
        const answer = yield messageSocket.sendRequest("init", { data, settings, hooks: Object.keys(hooks) });
        const methods = {};
        answer.forEach((type) => {
          methods[type] = (payload) => __async(this, null, function* () {
            if (type === "updateHooks") {
              return yield messageSocket.sendRequest(type, updateHooks(payload));
            }
            return yield messageSocket.sendRequest(type, payload);
          });
        });
        clearTimeout(timeoutId);
        resolve({
          methods,
          terminate: messageSocket.terminate
        });
      });
    }
  });
}
let currentZIndex = 0;
function initFullscreenPlugin(_0, _1) {
  return __async(this, arguments, function* ({ data, settings, hooks }, { id, src, parentElem, beforeInit = null, timeout }) {
    let container = document.createElement("div");
    container.id = id;
    container.style.position = "fixed";
    container.style.display = "flex";
    container.style.top = "0";
    container.style.left = "0";
    container.style.zIndex = 0;
    let defaultAnimationTime = 500;
    let hiddenPosition = "translate3d(-100vw, 0px, 0px) scale(1)";
    let hiddenOpacity = 0;
    container.style.transform = hiddenPosition;
    container.style.opacity = hiddenOpacity;
    container.style.width = "100%";
    container.style.height = "100%";
    container.style.border = "0";
    container.style.margin = "0";
    container.style.padding = "0";
    container.style.transition = "transform 0s";
    const parent = parentElem || document.body;
    parent.appendChild(container);
    let splashScreen;
    function showSplashScreen() {
      if (!settings.splashScreenUrl)
        return;
      return new Promise((resolve) => {
        splashScreen = document.createElement("iframe");
        splashScreen.src = settings.splashScreenUrl;
        splashScreen.style.position = "absolute";
        splashScreen.style.top = "0";
        splashScreen.style.left = "0";
        splashScreen.style.width = "100%";
        splashScreen.style.height = "100%";
        splashScreen.style.opacity = "1";
        splashScreen.style.border = "0";
        splashScreen.style.margin = "0";
        splashScreen.style.padding = "0";
        splashScreen.style.transition = "opacity 0.5s";
        container.appendChild(splashScreen);
        splashScreen.addEventListener("load", resolve, { once: true });
      });
    }
    function hideSplashScreen() {
      if (!splashScreen) {
        return;
      }
      splashScreen.style.opacity = "0";
      setTimeout(() => {
        splashScreen.remove();
      }, 500);
    }
    let isVisible = false;
    function show({ x = "-100vw", y = "0px", opacity = 0.5, scale = 1, time = defaultAnimationTime } = {}) {
      if (isVisible)
        return;
      if (isNaN(time)) {
        throw new Error("Animation time must be a number!");
      }
      defaultAnimationTime = time;
      hiddenPosition = `translate3d(${x}, ${y}, 0px) scale(${scale})`;
      hiddenOpacity = opacity;
      currentZIndex++;
      container.style.zIndex = currentZIndex;
      container.style.overflow = "hidden";
      window.requestAnimationFrame(() => {
        container.style.transition = "transform 0s";
        container.style.transform = `translate3d(${x}, ${y}, 0px) scale(${scale})`;
        container.style.opacity = opacity;
        container.style.display = "block";
        return new Promise((resolve) => {
          window.requestAnimationFrame(() => {
            container.style.transition = `all ${time}ms`;
            container.style.transform = "translate3d(0px, 0px, 0px) scale(1)";
            container.style.opacity = "1";
            isVisible = true;
            const transitionEnded = (e) => {
              if (e.propertyName !== "opacity" && e.propertyName !== "transform")
                return;
              resolve();
            };
            container.addEventListener("transitionend", transitionEnded, { once: true });
          });
        });
      });
    }
    function hide() {
      if (!isVisible)
        return;
      return new Promise((resolve) => {
        container.style.overflow = "hidden";
        container.style.transition = `transform ${defaultAnimationTime / 1e3}s`;
        container.style.opacity = hiddenOpacity;
        container.style.transform = hiddenPosition;
        isVisible = false;
        if (hiddenOpacity === 0) {
          container.style.display = "none";
        }
        const transitionEnded = (e) => {
          if (e.propertyName !== "opacity" && e.propertyName !== "transform")
            return;
          resolve();
        };
        container.addEventListener("transitionend", transitionEnded, { once: true });
      });
    }
    function destroy() {
      return __async(this, null, function* () {
        yield hide();
        container.remove();
        container = null;
      });
    }
    const { methods } = yield createInitPlugin({ data, settings, hooks }, { container, src, beforeInit, timeout });
    return {
      _container: container,
      _src: src,
      methods,
      showSplashScreen,
      hideSplashScreen,
      show,
      hide,
      destroy
    };
  });
}
function initInlinePlugin(_0, _1) {
  return __async(this, arguments, function* ({ data, settings, hooks }, { src, container, beforeInit = null, timeout }) {
    const { methods } = yield createInitPlugin({
      data,
      settings,
      hooks
    }, {
      container,
      src,
      timeout,
      beforeInit
    });
    function destroy() {
      while (container.firstChild) {
        container.firstChild.remove();
      }
    }
    return {
      _container: container,
      methods,
      destroy
    };
  });
}
function providePlugin({ hooks = [], methods = {}, validator = null } = {}, currentWindow = window, targetWindow = window.parent) {
  const messageSocket = new PostMessageSocket(currentWindow, targetWindow);
  const updateHooksList = initUpdateHookList(hooks, messageSocket, validator);
  Object.keys(methods).forEach((methodName) => {
    if (methodName === "updateHooks") {
      messageSocket.addListener("updateHooks", (payload) => __async(this, null, function* () {
        return yield methods.updateHooks(yield updateHooksList(payload));
      }));
    } else {
      messageSocket.addListener(methodName, (payload) => methods[methodName](payload));
    }
  });
  let ack = false;
  function sendDomReady() {
    return __async(this, null, function* () {
      messageSocket.addListener("ackDomReady", () => {
        ack = true;
      }, { once: true });
      while (!ack) {
        yield new Promise((resolve) => {
          messageSocket.sendMessage("domReady", {});
          setTimeout(() => {
            resolve();
          }, 200);
        });
      }
    });
  }
  if (messageSocket.getDocument().readyState === "loading") {
    messageSocket.getDocument().addEventListener("DOMContentLoaded", sendDomReady, { once: true });
  } else {
    sendDomReady();
  }
  return new Promise((resolveProvidePlugin, rejectProvidePlugin) => {
    messageSocket.addListener("init", onInit, { once: true });
    function onInit() {
      return __async(this, arguments, function* ({ data = null, settings = null, hooks: hooks2 = [] } = {}) {
        ack = true;
        try {
          if (typeof validator === "function") {
            yield validator({ data, settings });
          }
          const terminate = () => {
            messageSocket.terminate();
          };
          resolveProvidePlugin({
            data,
            settings,
            hooks: yield updateHooksList(hooks2),
            terminate
          });
        } catch (error) {
          rejectProvidePlugin(error);
          throw new Error(error.message);
        }
        return Object.keys(methods);
      });
    }
  });
}
export { initFullscreenPlugin, initInlinePlugin, providePlugin };
//# sourceMappingURL=pluginInterface.js.map
